module.exports = require("core-js/modules/web.url.js");